import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Selected_Index, RECHARGE_INVENTORY_TYPE } from '../../../../../../constants/external-constants';
import { validateAccessModule } from '../../../../../../utils/helpers.utils';
import { ACCESS_MODULE, MATRIX_INDICATOR } from '../../../../../../utils/rbac-constants.utils';
import ButtonIcon from '../../../../../button';
import { ListTabButton } from '../../../../../common/list-tab/list-tab-button.component';
import { rechargingInventoryActions } from "../../../../../../store/external/recharge-reducer/recharging-inventory-reducer/recharging-inventory-reducer";
import RechargingOtcForm from '../details/recharging-otc-form.component';
import RechargingEquipmentComments from '../../../recharging-inventory/equipment/comment/recharging-equipment-comment.component'

import RechargingHistory from '../../history/recharging-history.component';
class RechargingOtcDetailsView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedIndex: "0",
            listTab: [
                {
                    "id": Selected_Index.i_Zero,
                    "label": "Details",
                    "hidden": false
                },
                {
                    "id": Selected_Index.i_One,
                    "label": "Comments",
                    "hidden": false,
                    "disable": true
                },
                {
                    "id": Selected_Index.i_Two,
                    "label": "History",
                    "hidden": false,
                    "disable": true
                }
            ],
        };
    }

    componentDidMount = () =>{
        window.scrollTo(0, 0);
    }
    
    FilterIndex = (tabIndex) => {
        this.setState({ selectedIndex: tabIndex });
        this.renderTabContent(tabIndex)
    }

    handlecloseForm = () => {
        
        const { closeFormAction } = this.props;
        closeFormAction()
    }

    renderTabContent = (index) => {
        this.setState({ selectedTab: index });
    }

    activeListTab = (listTab) => {
        const { rechargeInventoryId } = this.props;

        return listTab.map(item => {
            var disabled = item.disable;
            if ((parseInt(item.id) === parseInt(Selected_Index.i_One) || parseInt(item.id) === parseInt(Selected_Index.i_Two)) && rechargeInventoryId > 0) {
                disabled = false;
            }

            return {
                ...item,
                disable: disabled
            };
        })
    }

    render() {
        const { isCreateNew, rechargeInventoryId } = this.props;
        const { listTab, selectedIndex } = this.state;
    
        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdRechargingInventoryR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdRechargingInventoryRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdRechargingInventoryRW])
        const roles = {
            isReadOnly,
            isReadAndWrite,
            isReadAndExtractOnly
        }
        return (
            <div className="layout-container">
                <ButtonIcon onClick={this.handlecloseForm} iconLeft="chevron-left" iconSize="17px" customClassName="manage-invoice-back-button" labelName="Back" />
                {listTab ? <ListTabButton listData={this.activeListTab(listTab)} selectedIndex={selectedIndex} FilterIndex={this.FilterIndex} />
                    : null}
                <div className={`${this?.props?.isMultiContainer ? "" : "details-container"} date-picker-main-container`}>
                    {(this.state.selectedIndex === Selected_Index.i_Zero || this.props.selected) &&
                        <RechargingOtcForm rechargeInventoryId={rechargeInventoryId} handleCloseForm={this.handlecloseForm} isCreateNew={isCreateNew} />
                    }

                    {this.state.selectedIndex === Selected_Index.i_One &&
                        <RechargingEquipmentComments 
                            rechargeInventoryId={rechargeInventoryId}
                            isReadOnly={isReadOnly}
                            isReadAndExtractOnly={isReadAndExtractOnly}
                            isReadAndWrite={isReadAndWrite}
                            isCreateNew = {false}
                        />}
                    {this.state.selectedIndex === Selected_Index.i_Two &&
                        <RechargingHistory rechargeInventoryId={rechargeInventoryId}
                            rechargingInventoryTypeId={parseInt(RECHARGE_INVENTORY_TYPE["OTC"].id)}
                            hideCustomColumn={true} 
                            isReadOnly={isReadOnly}
                            isReadAndExtractOnly={isReadAndExtractOnly}
                            isReadAndWrite={isReadAndWrite} />
                    }
                </div>
            </div>
        );
    }
}

export default withRouter(connect(
    state => {
        const { rechargingInventory } = state;
        return {
            rechargingInventory
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, rechargingInventoryActions),
        dispatch
    )
)(RechargingOtcDetailsView));